import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { startContactClickTracking } from './utils/analytics';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import MobileCallBar from './components/MobileCallBar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Article from './pages/Article';
import PracticeAreas from './pages/PracticeAreas';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ArvOgTestament from './pages/ArvOgTestament';
import FastEiendom from './pages/FastEiendom';
import Arbeidsrett from './pages/Arbeidsrett';
import LawyerDetail from './pages/LawyerDetail';

const App: React.FC = () => {
  // Track phone/email link clicks site-wide (the main law-firm conversions).
  useEffect(() => startContactClickTracking(), []);

  return (
  <Router>
    <ScrollToTop />
    <CookieConsent />
    <MobileCallBar />
    <div className="pb-14 md:pb-0" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-oss" element={<About />} />
          <Route path="/om-oss/:slug" element={<LawyerDetail />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/fagomrader" element={<PracticeAreas />} />
          <Route path="/oppdragsvilkar" element={<Terms />} />
          <Route path="/personvern" element={<Privacy />} />
          <Route path="/arv-og-testament" element={<ArvOgTestament />} />
          <Route path="/fast-eiendom" element={<FastEiendom />} />
          <Route path="/arbeidsrett" element={<Arbeidsrett />} />
          <Route path="/article/:slug" element={<Article />} />
          {/* Stray URLs Google had indexed as soft 404s — redirect to the right place */}
          <Route path="/Advokat" element={<Navigate to="/" replace />} />
          <Route path="/member/thorleif" element={<Navigate to="/om-oss/thorleif-bruland" replace />} />
          <Route path="*" element={<div className="container text-center py-8">Side ikke funnet.</div>} />
        </Routes>
      </main>
      <Footer />
    </div>
  </Router>
  );
};

export default App;
